import { appServices } from '../helpers/app-services/AppServices';

const userImageProvider = async assetId => {
  return await appServices.getAssetUrl(assetId);
};

export default userImageProvider;
